const order = [
  'quantity_quarantine_pre_shipment',
  'decision_quarantine_pre_shipment',
  'quantity_laboratory_analytical_uses',
  'decision_laboratory_analytical_uses',
  'quantity_essential_uses',
  'decision_essential_uses',
  'quantity_critical_uses',
  'decision_critical_uses',
  'quantity_high_ambient_temperature',
  'decision_high_ambient_temperature',
  'quantity_process_agent_uses',
  'decision_process_agent_uses',
  'quantity_other_uses',
  'decision_other_uses',
  'quantity_polyols',
  'decision_polyols'
]
export default order
